import { useContext, useEffect } from 'react';
import { AccountContext } from '../../AccountContext';
import { useGetNosiasForAccount, useCurrentBillingPeriod } from '@app/sdk';
import { ScrollableContentContainer } from '../../../tms/components/ScrollableContentContainer';
import { JsonViewer } from '@textea/json-viewer';
import { MessageHeader, MessageContent, Message, Icon } from 'semantic-ui-react';
import NosiaView from './NosiaView';

export default function NosiaOverview() {
  const { accountId, selectedNosia, nosiaJsonView } = useContext(AccountContext);
  const { data: nosias } = useGetNosiasForAccount(accountId);

  return (
    <>
      {!selectedNosia ? (
        <div>
          <Message>
            <MessageHeader>
              <Icon name="info circle" />
              NOSIA
            </MessageHeader>
            <MessageContent>No Notice of sums in arrears</MessageContent>
          </Message>
        </div>
      ) : nosiaJsonView ? ( 
        <div>
          <ScrollableContentContainer height={'450px'}>
            <JsonViewer value={nosias} theme={'auto'} />
          </ScrollableContentContainer>
        </div>
      ) : (
        <NosiaView {...selectedNosia} />
      )}
    </>
  );
}
